var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppDialog",
    {
      attrs: {
        activatorText: "Send User Invite",
        title: "Send user invite",
        action: "Send",
        "action-disabled": !_vm.email || !_vm.isEmailValid(_vm.email)
      },
      on: {
        action: function($event) {
          return _vm.handleSend()
        }
      }
    },
    [
      _c("v-text-field", {
        attrs: {
          label: "Email",
          type: "email",
          rules: [
            function(v) {
              return _vm.isEmailValid(v) || "E-mail must be valid"
            }
          ],
          solo: ""
        },
        model: {
          value: _vm.email,
          callback: function($$v) {
            _vm.email = $$v
          },
          expression: "email"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }